<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-extra-large"
    title="インターネットType4・セキュリティアプライアンス追加"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-4">
            <div class="modal-body">
              <!-- VPN/VNコード サイト選択 -->
              <v-card variant="outlined" class="mx-4 mb-4">
                <v-card-text>
                  <span class="text-h6">VPN/VNコード サイト選択</span>
                  <v-container>
                    <!-- VPNコード -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="vpnVnCode"
                          v-model="postItem.vpnVnCode"
                          label="VPN/VNコード"
                          :rules="{ required: true }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge item="VPN/VNコード" :isInfo="false" />
                          <app-select
                            item-title="text"
                            item-value="value"
                            :items="[{ text: '', value: '' }, ...vpnVnList]"
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          >
                          </app-select>
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- メインサイト -->
                    <v-row>
                      <v-col>
                        <app-badge
                          item="メインサイト"
                          :isRequired="false"
                          :isInfo="false"
                        />
                        <v-radio-group
                          inline
                          v-model="postItem.mainSite"
                          hide-details
                        >
                          <v-radio label="東京" value="TOKYO" />
                          <v-radio label="大阪" value="OSAKA" />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <!-- Type4名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="type4Name"
                          v-model="postItem.type4Name"
                          label="Type4名"
                          :rules="{ required: true, max: { length: 20 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="Type4名"
                            :isRequired="true"
                            placement="end"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- セキュリティアプライアンス契約 -->
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  セキュリティアプライアンス契約
                </v-card-title>
                <v-card-text>
                  <div>
                    (NATは必ず契約されます。UTM、インターネットFWのどちらかの契約が必ず必要になります。)
                  </div>
                  <v-container>
                    <v-row>
                      <v-col
                        ><v-radio-group
                          v-model="postItem.applianceType"
                          hide-details
                        >
                          <v-radio
                            label="UTM(1Gbpsベストエフォート)"
                            value="UTM"
                          />
                          <v-radio
                            label="インターネットFW(100Mbpsベストエフォート)"
                            value="IFW"
                          /> </v-radio-group
                      ></v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-badge
                          item="デフォルトポリシー選択"
                          :isInfo="false"
                          :isRequired="false"
                        />
                        <v-radio-group
                          v-model="postItem.policyType"
                          hide-details
                        >
                          <v-expansion-panels
                            flat
                            v-model="isCollapsed_OnewaySp"
                          >
                            <v-expansion-panel :value="true">
                              <v-expansion-panel-title
                                static
                                class="w-auto py-0"
                              >
                                <template #default>
                                  <v-radio
                                    label="編集可能デフォルトポリシー 片方向(特定サービス)"
                                    value="ALLOW_SPECIFIC_ONE_WAY"
                                    @click.stop
                                  />
                                </template>
                              </v-expansion-panel-title>
                              <v-expansion-panel-text>
                                <default-policy-oneway-sp
                                  :appliance-type="postItem.applianceType"
                                ></default-policy-oneway-sp>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>

                          <v-expansion-panels
                            flat
                            v-model="isCollapsed_OnewayAny"
                          >
                            <v-expansion-panel :value="true">
                              <v-expansion-panel-title
                                static
                                class="w-auto py-0"
                              >
                                <template #default>
                                  <v-radio
                                    label="編集可能デフォルトポリシー 片方向(any)"
                                    value="ALLOW_ALL_ONE_WAY"
                                    @click.stop
                                  />
                                </template>
                              </v-expansion-panel-title>
                              <v-expansion-panel-text>
                                <default-policy-oneway-any
                                  :appliance-type="postItem.applianceType"
                                ></default-policy-oneway-any>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>

                          <v-expansion-panels
                            flat
                            v-model="isCollapsed_InteractiveAny"
                          >
                            <v-expansion-panel :value="true">
                              <v-expansion-panel-title
                                static
                                class="w-auto py-0"
                              >
                                <template #default>
                                  <v-radio
                                    label="編集可能デフォルトポリシー 双方向(any)"
                                    value="ALLOW_ALL_TWO_WAY"
                                    @click.stop
                                  />
                                </template>
                              </v-expansion-panel-title>
                              <v-expansion-panel-text>
                                <default-policy-interactive-any
                                  :appliance-type="postItem.applianceType"
                                ></default-policy-interactive-any>
                              </v-expansion-panel-text>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- インターネット契約 -->
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  インターネット契約
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="インターネット帯域">
                          <template #value>
                            <div class="ml-3">
                              <template v-if="postItem.applianceType === 'IFW'">
                                100Mbpsベストエフォート
                              </template>
                              <template v-if="postItem.applianceType === 'UTM'">
                                1Gbpsベストエフォート
                              </template>
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="グローバルIP">
                          <template #value>
                            <div class="ml-3">
                              契約時グローバルIPは、必ず1個払い出されます。
                            </div>
                            <div class="d-flex align-center">
                              <div class="v-col-3">追加グローバルIP数</div>
                              <div class="v-col-1 pr-0 mr-0">0 個</div>
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-badge
                          item="M365経路制御オプション"
                          :isInfo="false"
                          :isRequired="false"
                        />
                        <v-radio-group
                          inline
                          v-model="postItem.isMicrosoft365"
                          hide-details
                        >
                          <v-radio label="OFF" :value="false" />
                          <v-radio label="ON" :value="true" />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="状態">
                          <template #value>
                            <span class="ml-3">
                              {{ $filter.enumTo("UNCONNECTED", "status") }}
                            </span>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- 保守連絡先情報 -->
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  保守連絡先情報
                </v-card-title>
                <v-card-text>
                  <div>契約情報の変更は紙申込でのみ可能です。</div>
                  <v-container>
                    <!--   コピー元回線番号 -->
                    <app-badge
                      item="コピー元回線番号"
                      :msg="$filter.message('info_maintenance_copy')"
                      :isRequired="false"
                      placement="end"
                    />
                    <v-row>
                      <v-col cols="6">
                        <app-multi-select
                          v-model="selectedUnit"
                          :options="sortType4Items"
                          :custom-label="labelUnit"
                          track-by="wnumberMainAct"
                          hide-details
                          class="mb-2"
                        >
                          <template #beforeList>
                            <div class="multiselect-thead">
                              <p>VPN/VNコード</p>
                              <p>Type4名</p>
                              <p>W番号</p>
                            </div>
                          </template>
                          <template #option="{ option }">
                            <div class="multiselect-tbody">
                              <p>{{ option.vpnVnCode }}</p>
                              <p>{{ option.type4Name }}</p>
                              <p>{{ option.wnumberMainAct }}</p>
                            </div>
                          </template>
                        </app-multi-select>

                        <v-alert
                          v-if="maintenanceInfoErr"
                          density="compact"
                          :text="`選択された「コピー元回線番号」には、保守連絡先情報が登録されておりません。`"
                        />
                      </v-col>
                      <v-col>
                        <v-btn
                          color="primary"
                          @click="setProperty"
                          :disabled="!selectedUnit"
                          >コピー
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- 会社名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="company"
                          v-model="postItem.maintenance.company"
                          label="会社名"
                          :rules="{ required: true, max: { length: 35 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="会社名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '35',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 部署名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="department"
                          v-model="postItem.maintenance.department"
                          label="部署名"
                          :rules="{ required: true, max: { length: 35 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="部署名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '35',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 担当者名 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="name"
                          v-model="postItem.maintenance.name"
                          label="担当者名"
                          :rules="{ required: true, max: { length: 20 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="担当者名"
                            :msg="
                              $filter.message('info_max_length', {
                                maxLength: '20',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- 電話番号 -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="phone"
                          v-model="postItem.maintenance.phone"
                          label="電話番号"
                          :rules="{
                            required: true,
                            is_phone_number: { max: 11 },
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="電話番号"
                            :msg="
                              $filter.message('info_tel', {
                                max: '11',
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- メールアドレス -->
                    <v-row>
                      <v-col cols="6">
                        <validation-provider
                          name="email"
                          v-model="postItem.maintenance.email"
                          label="メールアドレス"
                          :rules="{
                            required: true,
                            max: { length: 127 },
                            is_email: true,
                          }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-badge
                            item="メールアドレス"
                            :msg="
                              $filter.message('info_sign_num_max', {
                                sign: '. _ ! ? { } + - * / = # % $ & ^ ` ~ | @',
                                max: 127,
                              })
                            "
                            placement="end"
                          />
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">追加</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  Type4Service,
  Type4ServicePostRequest,
  VpnVnCode,
} from "@/apis/ContractChangeType4Api";
import InternetType4ContractRegisterConfirm from "@/modals/applianceContractSetting/type4/contract/InternetType4ContractRegisterConfirm.vue";
import DefaultPolicyOnewaySp from "@/components/applianceContractSetting/DefaultPolicyOnewaySp.vue";
import DefaultPolicyOnewayAny from "@/components/applianceContractSetting/DefaultPolicyOnewayAny.vue";
import DefaultPolicyInteractiveAny from "@/components/applianceContractSetting/DefaultPolicyInteractiveAny.vue";
import type { ApplianceInfo } from "@/apis/ContractApi";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType4ContractRegister",
  props: {
    type4Items: {
      type: Array as PropType<ApplianceInfo[]>,
      required: true,
    },
  },
  components: {
    AppLabelGroup,
    DefaultPolicyInteractiveAny,
    DefaultPolicyOnewayAny,
    DefaultPolicyOnewaySp,
  },
  data() {
    return {
      /** 初期通信完了フラグ */
      isLoaded: false,
      type4Service: {} as Type4Service,
      postItem: {
        vpnVnCode: "",
        mainSite: "TOKYO",
        type4Name: "",
        applianceType: "UTM",
        policyType: "ALLOW_SPECIFIC_ONE_WAY",
        isMicrosoft365: false,
        maintenance: {
          company: "",
          department: "",
          name: "",
          phone: "",
          email: "",
        },
        note: null,
      } as Type4ServicePostRequest,
      isCollapsed_OnewaySp: false,
      isCollapsed_OnewayAny: false,
      isCollapsed_InteractiveAny: false,
      vpnVnList: [] as { value: string | null; text: string | null }[],
      selectedUnit: null as ApplianceInfo | null,
      maintenanceInfoErr: false,
    };
  },
  computed: {
    sortType4Items(): ApplianceInfo[] {
      return this.type4Items.sortBy(["vpnVnCode", "asc"]);
    },
  },
  watch: {
    /** 選択値変更時にエラーメッセージを非表示 */
    selectedUnit() {
      this.maintenanceInfoErr = false;
    },
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      this.vpnVnList = (
        await this.$api.contract_change_type4.getType4VpnVnList()
      ).map((e: VpnVnCode) => ({
        value: e.vpnVnCode,
        text: e.vnName ? `${e.vpnVnCode} (${e.vnName})` : `${e.vpnVnCode}`,
      }));
    },
    /** 確認モーダルの表示 */
    async submit() {
      await this.$modal.show(InternetType4ContractRegisterConfirm, {
        vpnVnCode: this.vpnVnList.find(
          (e) => e.value === this.postItem.vpnVnCode
        )?.text,
        postItem: this.postItem,
      });
      /** null設定 */
      this.postItem.note = this.postItem.note || null;

      await this.$api.contract_change_type4.postType4Service(this.postItem);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    labelUnit({ vpnVnCode, type4Name, wnumberMainAct }: ApplianceInfo): string {
      return `${vpnVnCode} / ${type4Name} / ${wnumberMainAct}`;
    },
    async setProperty() {
      if (this.selectedUnit) {
        const setForm = (
          await this.$api.contract_change_type4.getType4Service(
            this.selectedUnit.type4Id!
          )
        ).maintenance;
        if (setForm) {
          this.maintenanceInfoErr = false;
          this.postItem.maintenance = setForm;
        } else {
          this.maintenanceInfoErr = true;
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-expansion-panel-title:hover > .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}
:deep(.v-card.v-card--variant-outlined) {
  border-color: rgba(0, 0, 0, 0.125) !important;
}
// WVS2UI-13585 #169 ラジオボタンの編集可能デフォルトポリシーの上方向が見切れている
.v-expansion-panel-title {
  line-height: 1.5;
}
</style>
